import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/projects/portfolio/page.tsx");
